import React, { useCallback, useEffect, useState } from "react";
import SettingList from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier";
import { MockSetSubmission, getSubmissionSettings } from "./setting-submission.type";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";

const PAGE_KEY = "submission";

const SubmissionSet = () => {
  const { getToggle, setToggle, hydrateMany } = useSettingsDraft();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        const res = await getSubmissionSettings();
        if (!alive) return;

        const s = res.data.data.settings;

        hydrateMany({
          pageKey: PAGE_KEY,
          toggles: [{ groupId: 1, itemId: 1, value: !!s.read.autoMarkOnOpen }],
        });
      } catch (e) {
        console.error("GET submission settings failed:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [hydrateMany]);

  const isChecked = useCallback(
    (groupId: number, itemId: number) => getToggle(PAGE_KEY, groupId, itemId),
    [getToggle]
  );

  const onToggle = useCallback(
    (payload: {
      groupId: number;
      groupTitle: string;
      itemId: number;
      itemTitle: string;
      checked: boolean;
    }) => {
      setToggle({
        pageKey: PAGE_KEY,
        groupId: payload.groupId,
        groupTitle: payload.groupTitle,
        itemId: payload.itemId,
        itemTitle: payload.itemTitle,
        value: payload.checked,
      });
    },
    [setToggle]
  );

  return (
    <main>
      {MockSetSubmission.map((group) => (
          <SettingList
            key={group.id}
            groupId={group.id}
            mainTitle={group.title}
            paragraph={group.description}
            setList={group.items}
            isChecked={isChecked}
            onToggle={onToggle}
          />
        ))
      }
    </main>
  );
};

export default SubmissionSet;